import React from "react";
import { useInView } from "../hooks/useInView";
import LazyImage from "./LazyImage";
import { trackEvent } from "../utils/analytics";

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleContactClick = () => {
    trackEvent("kontakt_o_nas", {
      category: "O nas",
      label: "Przycisk kontaktu",
      section: "about",
    });
    scrollToSection("contact");
  };

  return (
    <section id="about" className="section-padding bg-[#FAFAFA]">
      <div className="container-custom">
        <div
          ref={ref}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center"
        >
          {/* Text Content */}
          <div
            className={`transition-all duration-700 ${
              inView ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <h2 className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-medium font-heading text-special1-500">
              O nas
            </h2>

            <div className="space-y-4 text-secondary-600 leading-relaxed">
              <p className="font-regular text-lg md:text-xl lg:text-2xl">
                Firma LUMAT to zespół ludzi z doświadczeniem sięgającym 2008
                roku. Od lat dostarczamy rozwiązania z zakresu{" "}
                <strong>automatyki</strong>, <strong>pneumatyki</strong>,{" "}
                <strong>hydrauliki</strong> i <strong>elektrotechniki</strong>,
                wspierając działy utrzymania ruchu i produkcji w całym kraju.
              </p>

              <p className="font-regular text-base md:text-lg">
                Naszym atutem jest{" "}
                <strong>
                  elastyczne podejście i umiejętność znajdowania rozwiązań nawet
                  w trudnych przypadkach
                </strong>
                . Nie boimy się wyzwań – pomagamy naszym klientom również wtedy,
                gdy inni nie potrafią znaleźć rozwiązania.
              </p>

              <p className="text-base md:text-lg">
                Z nami możesz liczyć na doradztwo techniczne, szybki serwis i
                dostęp do szerokiej gamy części – również tych trudno
                dostępnych.
              </p>
              <p className="text-base md:text-lg">
                <strong>
                  💡 LUMAT – doświadczenie, na którym możesz polegać
                </strong>
              </p>
            </div>

            <div className="mt-8">
              <button
                onClick={handleContactClick}
                className="btn-primary py-2 px-6 text-[20px]"
              >
                Skontaktuj się z nami
              </button>
            </div>
          </div>

          {/* Image */}
          <div
            className={`transition-all duration-700 delay-300 h-full ${
              inView ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <div className="relative h-full">
              <LazyImage
                src="/pictures/o_nas_lumat_1.jpeg"
                alt="O firmie Lumat - automatyka przemysłowa"
                className="w-full h-full object-cover rounded shadow"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
